import React from 'react';
import moment from 'moment';
import Button from 'react-bootstrap/Button';
import { MdFeedback } from 'react-icons/md';

const TimerControlHistory = ({ timerHistory, deleteHistory }) => {

    const formatTimerWithoutComparisonToCalendar = (t) => {
        return moment.utc(Math.abs(t)).format('m')
    }

    const getSubsubNameFromPath = (pathValue) => {
        if (!pathValue) {
            return ""
        }
        const slashIndex = pathValue.indexOf('/')
        if (slashIndex === -1) {
            return ""
        }
        return pathValue.slice(slashIndex + 1)
    }

    const getSubtaskNameFromPath = (pathValue) => {
        if (!pathValue) {
            return ""
        }
        const slashIndex = pathValue.indexOf('/')
        if (slashIndex === -1) {
            return pathValue
        }
        return pathValue.slice(0, slashIndex)
    }
    
    return(
        <>
            {timerHistory.map((it) => {
                const subtaskName = it.subtaskSname || it.subsub || getSubtaskNameFromPath(it.subsubPath || it.note || "")
                const subsubName = it.subsubName || getSubsubNameFromPath(it.subsubPath || it.note || "")
                return(
                    <div className='TimerHistoryEntry'>
                        <div className="TimerHistoryTitle">Subtask: {subtaskName} {it.allowFeedback > 0 ? <MdFeedback></MdFeedback> : <></>}</div>
                        <div>Subsub: {subsubName || '-'}</div>
                        <div>Done: {moment(it.done).format("HH:mm:ss")}</div>
                        <div>Duration: {formatTimerWithoutComparisonToCalendar(it.duration)}m</div>
                        <div>Note: {it.note}</div>
                        <Button variant="danger" onClick={() => deleteHistory(it)}>Delete</Button>
                    </div>
                )
            })}
        </>
    )

}

export default React.memo(TimerControlHistory);
